import React, { useMemo, useState } from "react";
import { Column } from "react-table";

import MtiButton from "../../../Buttons/MtiButton";
import { CartesianVector } from "../../../../Model/Waypoint";

import CommonTable from "../../../Common/CommonTable";

import styles from "./VectorCoordinate.module.css";

type VectorCoordinateProps = {
  cartesianVectors?: CartesianVector[];
  onRetrieve: () => void;
  onStore: () => void;
  onMove: (vector: CartesianVector) => void;
  setSelectedVector: (vector: CartesianVector) => void;
};

export default function VectorCoordinate(
  props: Readonly<VectorCoordinateProps>
) {
  const {
    cartesianVectors,
    onRetrieve,
    onStore,
    setSelectedVector: setReferenceVector,
    onMove,
  } = props;

  const [selectedRow, setSelectedRow] = useState<CartesianVector | null>(null);

  const cartesianColumn: Column<CartesianVector>[] = [
    {
      id: "x",
      Header: "X",
      accessor: (row: CartesianVector) => {
        return row.coordinate.x.toFixed(3);
      },
      width: "30%",
    },
    {
      id: "y",
      Header: "Y",
      accessor: (row: CartesianVector) => {
        return row.coordinate.y.toFixed(3);
      },
      width: "30%",
    },
    {
      id: "z",
      Header: "Z",
      accessor: (row: CartesianVector) => {
        return row.coordinate.z.toFixed(3);
      },
      width: "30%",
    },
    {
      id: "action",
      Header: "Action",
      accessor: (row: CartesianVector) => {
        const isDisabled = JSON.stringify(selectedRow) !== JSON.stringify(row);
        return (
          <MtiButton
            size="medium"
            colorVariant="black"
            onClick={() => {
              onMove(row);
            }}
            disabled={isDisabled}
          >
            MOVE
          </MtiButton>
        );
      },
      align: "center",
      width: "10%",
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.title}>Store and Retrieve Vector</div>
      <div className={styles.table}>
        {cartesianVectors && (
          <CommonTable<CartesianVector>
            data={cartesianVectors}
            columns={cartesianColumn}
            setSelectedRows={(rows) => {
              if (rows.length > 0) {
                setSelectedRow(rows[0]);
                setReferenceVector(rows[0]);
              }
            }}
            style={{ padding: 0 }}
            enableFilter={false}
            enablePagination={false}
            enableSelection
            enableMultiSelect={false}
            enableManualSorting={false}
            variant="depth-line"
            getRowStyle={(value) => {
              const isSelected =
                JSON.stringify(selectedRow) === JSON.stringify(value);
              return {
                ...(isSelected ? { background: "#cce1fd" } : {}),
                "&:hover": {
                  background: "red",
                },
                color: "black",
              };
            }}
            initialSelectedRowIndexes={[0]}
          />
        )}
      </div>
      <div className={styles.button}>
        <MtiButton
          size="medium"
          variant="secondary"
          colorVariant="black"
          onClick={onStore}
        >
          STORE
        </MtiButton>
        <MtiButton
          size="medium"
          variant="secondary"
          colorVariant="black"
          onClick={onRetrieve}
        >
          RETRIEVE
        </MtiButton>
      </div>
    </div>
  );
}
